import React from 'react'

export default function PotentialFraud() {
  return (
    <>
      <h2>Fraude potentielle</h2>
      <p>
        Nous suspectons une fraude. Vos gains sont bloqués à fins
        d'investigation.
      </p>
    </>
  )
}
